import { PromotionInterface, PromotionRequiredProductsInterface } from '@e3labs/isa-data-dictionary';
import { OrderItemCreateInterface } from '~/store/modules/order/order-interface';

export function getPendingPromotions(orderItems?: OrderItemCreateInterface[]): PromotionInterface[] | null {
  if (!orderItems) {
    return null;
  }
  const cartInventory = new Map<string, number>();
  orderItems.forEach(item => {
    const itemCode = item.externalCode;
    cartInventory.set(itemCode, item.soldQuantity);
  });

  const promotionsMap = new Map<string, PromotionInterface>();
  const requirementsByPromo = new Map<string, Map<string, PromotionRequiredProductsInterface>>();

  orderItems.forEach(item => {
    const promo = item.promotion?.promotion ?? item.promotion ?? null;

    const promoExternalCode = promo?.externalCode || promo?.aggregatorExternalCode;
    if (promo && promoExternalCode) {
      if (!promotionsMap.has(promoExternalCode)) {
        const { required, ...promoBase } = promo;
        promotionsMap.set(promoExternalCode, promoBase as PromotionInterface);
        requirementsByPromo.set(promoExternalCode, new Map<string, PromotionRequiredProductsInterface>());
      }

      if (promo.required && Array.isArray(promo.required)) {
        const reqMap = requirementsByPromo.get(promoExternalCode)!;

        promo.required.forEach(req => {
          const existingReq = reqMap.get(req.productExternalCode);
          if (!existingReq || req.minQuantity > existingReq.minQuantity) {
            reqMap.set(req.productExternalCode, { ...req });
          }
        });
      }
    }
  });

  const result: PromotionInterface[] = [];

  promotionsMap.forEach((promoBase, promoExternalCode) => {
    const reqMap = requirementsByPromo.get(promoExternalCode)!;
    const pendingRequired: PromotionRequiredProductsInterface[] = [];
    reqMap.forEach(req => {
      const qtyInCart = cartInventory.get(req.productExternalCode) || 0;
      if (qtyInCart < req.minQuantity) {
        pendingRequired.push(req);
      }
    });
    if (pendingRequired.length > 0) {
      result.push({
        ...promoBase,
        required: pendingRequired as [PromotionRequiredProductsInterface]
      });
    }
  });

  return result;
}
